import browserUpdate from 'browser-update';
import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/ie11"; // For IE 11 support
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import { store } from "./store/configureStore";
import { BrowserDetector } from './system/BrowserAgent/BrowserDetector';
import './sentry.config';




browserUpdate({ required: { e: 18, f: -3, o: -3, s: -1, c: -3 }, insecure: true, api: 2019.08, reminder: 0, test: false, no_permanent_hide: false })

ReactDOM.render(
  <Provider store={store}>
    <BrowserDetector />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
